import React from 'react';
import PropTypes from 'prop-types';

import {
  Form,
  Input,
  Modal,
} from 'antd';
import { withTranslation } from 'react-i18next';

const RESET_STATE = (state = {}) => {
  return {
    confirmDirty: false,

    ...state,
  }
}

class UserPasswordUpdateForm extends React.Component {
  static propTypes = {
    // form: PropTypes
    visible: PropTypes.bool,
    confirmLoading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
  }

  static defaultProps = {
    visible: false,
  }

  constructor(props) {
    super(props);
    this.state = RESET_STATE();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible && !this.props.visible) {
      this.props.form.resetFields();
      this.setState(RESET_STATE());
      return
    }
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      return Promise.reject('Two passwords that you enter is inconsistent!');
    }
    return Promise.resolve();
  };

  validateToNextPassword = (rule, value) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['password_confirmation']);
    }
    return Promise.resolve();
  };

  render() {
    const formItemLayout = {
      labelCol: { span: 12 },
      wrapperCol: { span: 12 },
    };

    return (
      <Modal
        visible={ this.props.visible }
        title={ this.props.t("Profile.actions.UpdatePassword") }
        okText={ this.props.t("actions.Submit") }
        onCancel={ this.props.onCancel }
        onOk={ this.props.onOk }
        confirmLoading={ this.props.confirmLoading }
      >
        <Form form={this.props.form} layout="horizontal">
          <Form.Item
            {...formItemLayout}
            label={ this.props.t("Profile.CurrentPassword") }
           name="current_password" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputCurrentPassword") }!` },
              ]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.NewPassword") }
           name="password" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputNewPassword") }!` },
                { min: 6, message: `${ this.props.t("Profile.messages.Form.PasswordShouldBeGreater") }!` },
                { validator: this.validateToNextPassword },
              ]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.ConfirmNewPassword") }
           name="password_confirmation" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseConfirmYourNewPassword") }!` },
                { validator: this.compareToFirstPassword },
              ]}>
            <Input.Password onBlur={this.handleConfirmBlur} />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const WrappedUserPasswordUpdateForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <UserPasswordUpdateForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUserPasswordUpdateForm);
